require('./icon-button.js');
require('./dist/drawer-dialog/ds6/drawer-dialog.css');
